import { TFunction } from "i18next";
import { AnyObjectSchema, array, mixed, object, string } from "yup";

export const createChallengeDetailsSchema = (t: TFunction): AnyObjectSchema =>
  object({
    challengeReason: string().required(t("challengeReason.errors.required")),

    challengeExplanation: string().trim().max(1000).required(t("challengeReason.errors.challengeExplanation")),

    documents: array()
      .of(
        object({
          id: string().required(),
          file: mixed<File>().required(),
          documentType: string().when("$requireDocumentTypes", {
            is: true,
            then: (schema) => schema.required(t("confirmDocuments.errors.documentTypeRequired")),
            otherwise: (schema) => schema.notRequired(),
          }),
        })
      )
      .max(20, t("errors.numOfFiles.title", { maxFilesCount: 20 }))
      .default([]),
  });
